"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ResponseObjectId () {
        return ResponseObjectId;
    },
    get transformObjectIdToString () {
        return transformObjectIdToString;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ResponseObjectId = _zod.z.instanceof(_bson.ObjectId).or(_zod.z.string());
const transformObjectIdToString = _zod.z.instanceof(_bson.ObjectId).transform((value)=>value.toString());
